import { AppState } from '@redux/types';
import { QueryState } from '@redux/reducers/queryParams/types';

export function _getQueryParams(state: AppState): QueryState {
  return state.queryParams;
}
